import React from "react"
import { Loader2 } from "lucide-react"
import { cn } from "../../../lib/utils"

/**
 * Spinner component using lucide-react Loader2 icon
 * Migrated from custom CSS spinner to lucide-react with Tailwind
 */
const Spinner = ({ size = "md", color, className }) => {
    const sizeMap = {
        xsm: "h-4 w-4",
        sm: "h-5 w-5",
        md: "h-6 w-6",
        lg: "h-7 w-7",
        xl: "h-8 w-8",
        xxl: "h-9 w-9",
    }

    const sizeClass = sizeMap[size] || sizeMap.md

    // Color mapping for common use cases
    const colorMap = {
        '#000': 'text-foreground',
        '#fff': 'text-background',
        '#ffffff': 'text-background',
        'white': 'text-background',
        'black': 'text-foreground',
    }

    const colorClass = color && colorMap[color.toLowerCase()] ? colorMap[color.toLowerCase()] : ''

    return (
        <div className="inline-flex items-center justify-center" role="status">
            <Loader2 
                className={cn(
                    "animate-spin",
                    sizeClass,
                    colorClass,
                    className
                )}
                style={color && !colorClass ? { color } : undefined}
            />
            <span className="sr-only">Loading...</span>
        </div>
    )
}

export default Spinner
